"use client";

import { usePathname } from "next/navigation";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ServicesMenu from "@/components/ServicesMenu";
import Image from "next/image";
import Link from "next/link";

const linkClass =
  "text-brand-secondary font-semibold underline underline-offset-2 hover:text-brand-primary transition-colors";

export default function NotFound() {
  const pathname = usePathname();
  const isEn = pathname.startsWith("/en");
  const locale = isEn ? "en" : "sv";

  return (
    <>
      <Header locale={locale} />
      <main className="flex flex-col items-center justify-center px-6 pt-32 pb-20 lg:pt-40 lg:pb-28 min-h-[70vh]">
        <h1 className="text-4xl md:text-5xl font-heading font-extrabold text-brand-dark text-center mb-4">
          {isEn ? "Page not found" : "Sidan kunde inte hittas"}
        </h1>
        <p className="text-lg text-gray-600 text-center max-w-lg mb-6">
          {isEn
            ? "Sorry, but the page you were looking for could not be found."
            : "Sidan du letade efter verkar inte finnas."}
        </p>
        <p className="text-base text-gray-600 text-center max-w-xl mb-10">
          {isEn ? (
            <>
              You can return to our{" "}
              <Link href="/en" className={linkClass}>front page</Link>
              ,{" "}
              <Link href="/en/contact-us" className={linkClass}>contact us</Link>
              {" "}or call us directly at:{" "}
              <a href="tel:+46851708281" className={linkClass}>08-517 082 81</a>
              {" "}if you can&apos;t find what you&apos;re looking for.
            </>
          ) : (
            <>
              Du kan gå tillbaka till vår{" "}
              <Link href="/" className={linkClass}>förstasida</Link>
              ,{" "}
              <Link href="/kontakta-oss" className={linkClass}>kontakta oss</Link>
              {" "}eller ring direkt på:{" "}
              <a href="tel:+46851708281" className={linkClass}>08-517 082 81</a>
              {" "}om du inte kan hitta vad du letar efter.
            </>
          )}
        </p>

        <Image
          src="/404-illustration.png"
          alt={isEn ? "Ungdomskraft workers with pickup truck" : "Ungdomskraft medarbetare med pickup"}
          width={720}
          height={400}
          className="w-full max-w-4xl h-auto"
          priority
        />
      </main>
      <ServicesMenu locale={locale} />
      <Footer locale={locale} />
    </>
  );
}
